import { IntlContext } from "context";
import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "routes";
import Footer from "components/Layout/Main/Footer";

const ConfirmPaymentBooking: React.FC = () => {
    const intl = useContext(IntlContext);

    return (
        <React.Fragment>
            <div className="register">
                <div className="container">
                    <div className="register__container margin-top--3">
                        <h1 className="h2 text-center margin-bottom--3">
                            {intl.formatMessage("booking.confirm.label.title")}
                        </h1>
                        <p className="register__subtitle">{intl.formatMessage("booking.confirm.label.message")}</p>
                        <div className="flex flex--justify-content-center">
                            <NavLink className="btn btn--primary btn--square" to={ROUTES.MY_RESERVATIONS}>
                                {intl.formatMessage("booking.confirm.label.back_bookings")}
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </React.Fragment>
    );
};

export default ConfirmPaymentBooking;
